module.exports = __webpack_public_path__ + "img/shipo-menu-sales-plan-white.9e8914f3.svg";